import { LegalBrowserScreen } from '@/features/legal/LegalBrowserScreen';
import { APP_CONFIG } from '@/lib/app/config';

export default function PrivacyPolicyNativeScreen() {
  return <LegalBrowserScreen title="Privacy Policy" url={APP_CONFIG.privacyPolicyURL} />;
}
